import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { SectionTitle } from '~/components/section-title/SectionTitle';
import * as BrandsAndProductsStyles from '~/modules/overview-knowledge-graph/components/brands-and-products/BrandsAndProducts.styles';
import * as CompetitorsKnowledgeGraphStyles from '~/modules/overview-knowledge-graph/components/competitors-knowledge-graph/CompetitorsKnowledgeGraph.styles';
import * as GeographicExposureKnowledgeGraphStyles from '~/modules/overview-knowledge-graph/components/geographic-exposure-knowledge-graph/GeographicExposureKnowledgeGraph.styles';
import * as ThemeKnowledgeGraphStyles from '~/modules/overview-knowledge-graph/components/theme-knowledge-graph/ThemeKnowledgeGraph.styles';

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  width: 100%;
  margin-bottom: 32px;
  margin-top: 12px;
`;

export const StyledThemeKnowledgeGraph = styled.div`
  ${SectionTitle.Styled.Title} {
    ${typographyV2.bodyMd};
  }
  ${SectionTitle.Styled.TitleWrapper} {
    margin-bottom: 8px;
  }

  ${ThemeKnowledgeGraphStyles.ThemeRow} {
    padding: 14px 12px;
  }
`;

export const StyledCompetitorsKnowledgeGraph = styled.div`
  ${SectionTitle.Styled.Title} {
    ${typographyV2.bodyMd};
  }
  ${SectionTitle.Styled.TitleWrapper} {
    margin-bottom: 8px;
  }

  ${CompetitorsKnowledgeGraphStyles.CompetitorRow} {
    padding: 14px 12px;
  }
`;

export const StyledGeographicExposureKnowledgeGraph = styled.div`
  ${SectionTitle.Styled.Title} {
    ${typographyV2.bodyMd};
  }
  ${SectionTitle.Styled.TitleWrapper} {
    margin-bottom: 8px;
  }

  ${GeographicExposureKnowledgeGraphStyles.CountryRow} {
    padding: 14px 12px;
  }
`;

export const StyledBrandsAndProducts = styled.div`
  ${SectionTitle.Styled.Title} {
    ${typographyV2.bodyMd};
  }
  ${SectionTitle.Styled.TitleWrapper} {
    margin-bottom: 8px;
  }

  ${BrandsAndProductsStyles.Row} {
    padding: 14px 12px;
  }
`;
